export default "skymp5-front/88a868e753f79f8cb51565dd11b3d69f.wav";